import { create } from 'zustand';
import { startOfWeek, addDays } from "date-fns";

interface TimeState {
    formData: Record<string, any>;
    setFormData: (formData: Record<string, any>) => void;

    users: any[];
    setUsers: (users: any[]) => void;

    tab: string;
    setTab: (tab: string) => void;

    idUserSelected: number;
    setIdUserSelected: (idUserSelected: number) => void;

    selectedDate: Date;
    setSelectedDate: (date: Date) => void;

    weekDays: Date[];
    updateWeek: (date: Date) => void;

    libelles: any[];
    setLibelles: (libelles: any[]) => void;

    clients: any[];
    setClients: (clients: any[]) => void;

    missions: any[];
    setMissions: (missions: any[]) => void;

    times: any[];
    setTimes: (times: any[]) => void;

    update: boolean;
    setUpdate: (update: boolean) => void;

    idTimeSelected: number;
    setIdTimeSelected: (idTimeSelected: number) => void;

    timesToValidate: any[];
    setTimesToValidate: (timesToValidate: any[]) => void;

    idTimesSelected: number[], 
    setIdTimesSelected: (idTimesSelected:  number[] | ((prev:  number[]) =>  number[])) => void;

    dataFilter: any[];
    setDataFilter: (dataFilter: any[]) => void;

    requestsHolidays: any[];
    setRequestsHolidays: (requestsHolidays: any[]) => void;
    
    resetTime: () => void;
}

export const useTimeStore = create<TimeState>((set) => ({
    formData: {},
    setFormData: (formData) => set({formData}),

    tab: "Time",
    setTab: (tab) => set({tab}),

    users: [],
    setUsers: (users) => set({users}),

    idUserSelected: 0,
    setIdUserSelected: (idUserSelected) => set({idUserSelected}),

    selectedDate: new Date(),
    weekDays: Array.from({ length: 7 }, (_, i) =>
        addDays(startOfWeek(new Date(), { weekStartsOn: 1 }), i)
    ),
    setSelectedDate: (date) => set({ selectedDate: date }),
    updateWeek: (date) =>
        set({
        weekDays: Array.from({ length: 7 }, (_, i) =>
            addDays(startOfWeek(date, { weekStartsOn: 1 }), i)
        ),
        }),

    libelles: [],
    setLibelles: (libelles) => set({libelles}),

    clients: [],
    setClients: (clients) => set({clients}),

    missions: [],
    setMissions: (missions) => set({missions}),

    times: [],
    setTimes: (times) => set({times}),

    update: false,
    setUpdate: (update) => set({update}),

    idTimeSelected: 0,
    setIdTimeSelected: (idTimeSelected) => set({idTimeSelected}),

    timesToValidate: [],
    setTimesToValidate: (timesToValidate) => set({timesToValidate}),

    idTimesSelected: [],
    setIdTimesSelected: (update: any[] | ((prev: any[]) => any[])) =>
        typeof update === 'function' ? set((state) => ({ idTimesSelected: update(state.idTimesSelected) }))
                                     : set({ idTimesSelected: update }),
                                     
    dataFilter: [],
    setDataFilter: (dataFilter) => set({dataFilter}),

    requestsHolidays: [],
    setRequestsHolidays: (requestsHolidays) => set({requestsHolidays}),

    resetTime: () => set({formData: {}, libelles: [], clients: [], missions: [], idTimeSelected: 0, idTimesSelected: [], tab: "Time", dataFilter: []}),
}));